// extracted by mini-css-extract-plugin
module.exports =  {"CheckboxMenuSelect":"CheckboxMenuSelect__Y2-KQ","CheckboxMenuSelectPopup":"CheckboxMenuSelectPopup__Wb-cd"};